const loadedFonts: Set<string> = new Set();

export default defineNuxtPlugin((nuxtApp) => {
  const loadFontFromCDN = (selectedFont: string): void => {
    if (loadedFonts.has(selectedFont)) {
      console.log(`Font '${selectedFont}' is already loaded.`);
      return;
    }

    let fontParams = '';
    const fontNameLower: string = selectedFont.toLowerCase();

    switch (fontNameLower) {
      case 'roboto':
        fontParams = ':ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900';
        break;
      case 'inter':
        fontParams = ':wght@100;200;300;400;500;600;700;800;900';
        break;
      case 'roboto condensed':
        fontParams = ':ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900';
        break;
      case 'roboto mono':
        fontParams = ':ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700';
        break;
      default:
        fontParams = '';
    }

    const link: HTMLLinkElement = document.createElement('link');
    link.href = `https://fonts.googleapis.com/css2?family=${selectedFont.replace(/ /g, '+')}${fontParams}&display=swap`;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    
    loadedFonts.add(selectedFont);
    console.log(`Font '${selectedFont}' is now loaded.`);
  };

  // Provide the function globally to useNuxtApp()
  nuxtApp.provide('loadFontFromCDN', loadFontFromCDN);
});
